import FJUrlToVideoStart from './FJUrlToVideoStart';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import useLocalStore from '../../../hooks/useLocalStore';
import { setSliceUrlToVideoInput } from '../../../redux/slices/FJSliceTextToVideo';
const FJUrlToVideoStartContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const freeNumCreationInfo = useSelector(state => state.textToVideo.freeNumCreationInfo);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const urlToVideoInput = useSelector(state => state.textToVideo.urlToVideoInput);
    const onAnalyzeUrl = useCallback(() => {
        dispatch(FJActionTextToVideo.onAnalyzeUrlAction());
    }, [dispatch]);
    const onChangeUrlToVideoInput = useCallback(
        url => {
            dispatch(setSliceUrlToVideoInput(url));
        },
        [dispatch],
    );
    return (
        <FJUrlToVideoStart
            urlToVideoInput={urlToVideoInput}
            onAnalyzeUrl={onAnalyzeUrl}
            onChangeUrlToVideoInput={onChangeUrlToVideoInput}
            freeTimes={freeNumCreationInfo.analysisUrl}
            creditNumber={creditNumber}
        />
    );
};

export default FJUrlToVideoStartContainer;
